import { render, staticRenderFns } from "./PostUnavailableAlert.vue?vue&type=template&id=5c60cb9e&scoped=true&"
import script from "./PostUnavailableAlert.vue?vue&type=script&lang=js&"
export * from "./PostUnavailableAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c60cb9e",
  null
  
)

export default component.exports